import CommonAction from '../../shared/Http/Http';
import {POTENTIALS_GET} from '../constants';

export const getPotentials = body => CommonAction('POST', null, `backoffice-extended/potential-reports/get`, POTENTIALS_GET, body);